export enum BillingProfileEnum {
  GENERATE_CERT = "generate_cert",
  GENERATE_PAYMENT_REFERENCE = "generate_payment_reference",
  MANUAL_BILLING = "manual_billing"
}
